import {IDesignInfo, Template} from '@mintdata-wsp/common/state/DataState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {DesignsList} from '@mintdata-wsp/wsp/ui/views/workspace/home/designs/DesignsList';
import {DesignsFilter, DesignsFilterType} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import {DesignsSearch, DesignsSearchFilter} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsSearch';
import {TemplatesList} from '@mintdata-wsp/wsp/ui/views/workspace/home/templates/TemplatesList';
import * as classnames from 'classnames/bind';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./SearchPage.less');
const cx = classnames.bind(styles);

@observer
export class SearchPage extends BasePage<RouteComponentProps<any>, any>
{
    @computed
    private get _currentDesigns():Array<IDesignInfo>
    {
        const {allDesigns, getFilteredDesigns} = controllers.ui.mainPage;

        return getFilteredDesigns(allDesigns, DesignsFilterType.SearchDesigns);
    }

    @computed
    private get _publishedDesigns():Array<IDesignInfo>
    {
        const {allPublishedDesigns, getFilteredDesigns} = controllers.ui.mainPage;

        return getFilteredDesigns(allPublishedDesigns, DesignsFilterType.SearchApplications);
    }

    render()
    {
        let designsFilter;

        if( controllers.ui.mainPage.getDesignsSearchFilter() === DesignsSearchFilter.Templates )
            designsFilter = controllers.ui.mainPage.getDesignsFilter(DesignsFilterType.SearchTemplates);
        else if ( controllers.ui.mainPage.getDesignsSearchFilter() === DesignsSearchFilter.Applications )
            designsFilter = controllers.ui.mainPage.getDesignsFilter(DesignsFilterType.SearchApplications);
        else
            designsFilter = controllers.ui.mainPage.getDesignsFilter(DesignsFilterType.SearchDesigns);

        const {getFilteredTemplates} = controllers.ui.mainPage;

        let filterType = null;
        let designs:IDesignInfo[] = null;
        let templates:Template[] = null;

        if( designsFilter === DesignsFilter.All )
        {
            filterType = DesignsFilterType.SearchDesigns;
            designs = this._currentDesigns;
        }

        if( designsFilter === DesignsFilter.Published )
        {
            filterType = DesignsFilterType.SearchApplications;
            designs = this._publishedDesigns;
        }

        if( designsFilter === DesignsFilter.Templates )
        {
            filterType = DesignsFilterType.SearchTemplates;
            templates = getFilteredTemplates;
        }

        return (
            <Column className={cx(styles.page)}>

                <DesignsSearch />

                {designs && <DesignsList
                    filterType={filterType}
                    designs={designs}
                    // newDesign={true}
                    viewAsApplication={filterType === DesignsFilterType.SearchApplications}
                    highlightSearchTerm
                />}

                {templates && <TemplatesList
                    filterType={filterType}
                    templates={templates}
                    highlightSearchTerm
                />}

            </Column>
        );
    }

}
